export const API_CARDS = [
  {
    title: 'LoadingComponent',
    summary: 'Use <stackline-loading> when the loader itself is part of the template or needs to wrap projected content.'
  },
  {
    title: 'LoadingDirective',
    summary: 'Use [stacklineLoading] on cards, buttons, forms, and arbitrary host elements for overlay and inline patterns.'
  },
  {
    title: 'LoadingService',
    summary: 'Create and control fullscreen or ad-hoc loaders programmatically from your Angular services or components.'
  }
];
